import { useState } from 'react'
import { Studio } from '../Studio';
import { NewStudio } from './Studio'
import { DSFaz } from "./DSFaz";
import { MenuHome } from "./Menu";

export function Home() {
  const [menuSelected, setMenuSelected] = useState(0);

  const handleMenu = (valueMenu: number) => {
    setMenuSelected(valueMenu);
  }

  return (
    <>
      <MenuHome
        onSelect={menuSelected}
        onMenuSelect = {handleMenu}
      />
      
      <DSFaz />

      {menuSelected === 0 && (
        <NewStudio />
      )}

      {menuSelected === 2 && (
        <Studio />)
      /*import do componente studio Baseado no modelo antigo
        agora vai se chamar meusProjetos
      */}

    </>
  )
}
